import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Anchor from 'grommet/components/Anchor'
import Box from 'grommet/components/Box'
import Hero from 'grommet/components/Hero'
import Heading from 'grommet/components/Heading'
import Image from 'grommet/components/Image'
import Paragraph from 'grommet/components/Paragraph'

import Button from '../components/Button'
import Footer from '../components/Footer'
import Header from '../components/Header'

import '../styles/Menu.css'

class Menu extends Component {
  _getComponent (actionLink) {
    if (actionLink) {
      return (
        <Button
          label={actionLink.label}
          path={`/${actionLink.type}/${actionLink.id}`}
          primary />
      )
    } else {
      return null
    }
  }

  render () {
    const {
      title,
      subtitle,
      backgroundImage,
      actionLink,
      menuItems
    } = this.props.data

    return (
      <div className='Menu'>
        <Header />

        <Hero background={<Image src={backgroundImage} fit='cover' full />} backgroundColorIndex='dark'>
          <Box align='center'>
            <Heading margin='none'>{title}</Heading>
            <Paragraph align='center' size='large'>{subtitle}</Paragraph>
            {this._getComponent(actionLink)}
          </Box>
        </Hero>

        <div className='foo-container'>
          {menuItems.map((item, index) => {
            return (
              <Anchor animateIcon={false} path={`/${item.type}/${item.id}`} key={index}>
                <div className='foo' style={{backgroundImage: 'url(' + item.imageURL + ')'}}>
                  <div className='inner-foo'>
                    <Heading tag='h3'>{item.title}</Heading>
                    <Button
                      label='Find out more'
                      path={`/${item.type}/${item.id}`} />
                  </div>
                </div>
              </Anchor>
            )
          })}
        </div>

        <Footer
          isRoot={this.props.isRoot}
          history={this.props.history} />
      </div>
    )
  }
}

Menu.propTypes = {
  data: PropTypes.object,
  history: PropTypes.object,
  isRoot: PropTypes.bool
}

export default Menu



// WEBPACK FOOTER //
// ./src/layouts/Menu.js